module.exports = __webpack_public_path__ + "static/img/yewei2.628d5be2.png";